import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { globalStatusChange } from "../home/extra slices/commonSlice";
import {
  createProduct,
  fetchAllProductsByFilters,
  fetchBrands,
  fetchCategories,
  fetchProductById,
  updateProduct,
} from "./ProductApi";

const initialState = {
  products: [],
  brands: [],
  categories: [],
  status: "idle",
  totalItems: 0,
  selectedProduct: null,
};

export const fetchCategoriesAsync = createAsyncThunk(
  "product/fetchCategories",
  async () => {
    const response = await fetchCategories();

    return response.data;
  }
);
export const fetchBrandsAsync = createAsyncThunk(
  "product/fetchBrands",
  async () => {
    const response = await fetchBrands();
    return response.data;
  }
);
export const fetchAllProductsByFiltersAsync = createAsyncThunk(
  "product/fetchAllProductsByFilters",
  async (filter) => {
    const response = await fetchAllProductsByFilters(filter);
    return response.data;
  }
);
export const fetchProductByIdAsync = createAsyncThunk(
  "product/fetchProductById",
  async (id) => {
    const response = await fetchProductById(id);

    return response.data;
  }
);
export const createProductAsync = createAsyncThunk(
  "product/create",
  async (product) => {
    const response = await createProduct(product);
    return response.data;
  }
);

export const updateProductAsync = createAsyncThunk(
  "product/update",
  async (update) => {
    const response = await updateProduct(update);
    return response.data;
  }
);
export const productSlice = createSlice({
  name: "product",
  initialState,

  reducers: {
    clearSelectedProduct: (state) => {
      state.selectedProduct = null;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategoriesAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.categories = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchBrandsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBrandsAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.brands = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchAllProductsByFiltersAsync.pending, (state, action) => {
        state.status = "loading";
        //TODO: This is not working for some reason right now(the product list is not showing), we'll look into this later
        // action.meta.arg.dispatch(globalStatusChange("loading"));
      })
      .addCase(fetchAllProductsByFiltersAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.products = action.payload.products;
        state.totalItems = action.payload.totalItems;
        // action.meta.arg.dispatch(globalStatusChange("idle"));
      })
      .addCase(fetchProductByIdAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProductByIdAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.selectedProduct = action.payload;
      })
      .addCase(createProductAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createProductAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.products.push(action.payload);
      })
      .addCase(updateProductAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateProductAsync.fulfilled, (state, action) => {
        state.status = "idle";
        const index = state.products.findIndex(
          (product) => product.id === action.payload.id
        );
        state.products[index] = action.payload;
        state.selectedProduct = action.payload;
      });
  },
});
export const { clearSelectedProduct } = productSlice.actions;
export const selectAllProducts = (state) =>
  Array.isArray(state?.product?.products) ? state.product.products : [];
export const selectCategories = (state) =>
  Array.isArray(state?.product?.categories) ? state.product.categories : [];
export const selectBrands = (state) =>
  Array.isArray(state?.product?.brands) ? state.product.brands : [];
export const selectTotalItems = (state) => state?.product?.totalItems || 0;
export const selectProductById = (state) => state?.product?.selectedProduct;
export const selectProductStatus = (state) => state?.product?.status;

export default productSlice.reducer;
